import React from 'react';

import T from 'Utilities/texts';

import { Content } from 'LegacySBCRA/Content/Content';

import styles from './Header.scss';

const Header = React.memo(() => (
  <div className={styles.container}>
    <Content>
      <h1 className={styles.title}>
        {T.translate('aboutPage.header.title')}
      </h1>
    </Content>
  </div>
), () => true);

export default Header;
